/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConnexionStandardResponse,
  CreatePlateformeCommand,
  ErrorResponse,
  GetCurrentPlateformeResponse,
  GetPlateformeListResponse,
  GetPlateformes404Response,
  OperationResponse,
  PlateformeCorporatePersonneMoraleDto,
  PlateformeDto,
  UpdatePlateformeCommand,
} from '../models/index';
import {
    ConnexionStandardResponseFromJSON,
    ConnexionStandardResponseToJSON,
    CreatePlateformeCommandFromJSON,
    CreatePlateformeCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetCurrentPlateformeResponseFromJSON,
    GetCurrentPlateformeResponseToJSON,
    GetPlateformeListResponseFromJSON,
    GetPlateformeListResponseToJSON,
    GetPlateformes404ResponseFromJSON,
    GetPlateformes404ResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    PlateformeCorporatePersonneMoraleDtoFromJSON,
    PlateformeCorporatePersonneMoraleDtoToJSON,
    PlateformeDtoFromJSON,
    PlateformeDtoToJSON,
    UpdatePlateformeCommandFromJSON,
    UpdatePlateformeCommandToJSON,
} from '../models/index';

export interface CreatePlateformeRequest {
    createPlateformeCommand: CreatePlateformeCommand;
}

export interface DeletePlateformeRequest {
    plateformeId: string;
}

export interface GetPlateformeByIDRequest {
    plateformeId: string;
}

export interface GetPlateformeCorporatePersonneMoraleRequest {
    plateformeId: string;
}

export interface LinkBrokerRequest {
    plateformeId: string;
    brokerId: string;
}

export interface SwitchCurrentPlateformeRequest {
    plateformeId?: string;
}

export interface UnlinkBrokerRequest {
    plateformeId: string;
    brokerId: string;
}

export interface UpdatePlateformeByIdRequest {
    plateformeId: string;
    updatePlateformeCommand: UpdatePlateformeCommand;
}

export interface UploadPlateformeLogoRequest {
    plateformeId: string;
    fileType: number;
    file?: Blob;
}

/**
 * 
 */
export class PlateformesApi extends runtime.BaseAPI {

    /**
     * Create Plateforme
     */
    async createPlateformeRaw(requestParameters: CreatePlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createPlateformeCommand'] == null) {
            throw new runtime.RequiredError(
                'createPlateformeCommand',
                'Required parameter "createPlateformeCommand" was null or undefined when calling createPlateforme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/plateformes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlateformeCommandToJSON(requestParameters['createPlateformeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create Plateforme
     */
    async createPlateforme(requestParameters: CreatePlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createPlateformeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Declare a standard (password) login and align the current plateforme
     */
    async declarerConnexionStandardRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnexionStandardResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/current/connexion-standard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnexionStandardResponseFromJSON(jsonValue));
    }

    /**
     * Declare a standard (password) login and align the current plateforme
     */
    async declarerConnexionStandard(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnexionStandardResponse> {
        const response = await this.declarerConnexionStandardRaw(initOverrides);
        return await response.value();
    }

    /**
     * Delete Plateforme
     */
    async deletePlateformeRaw(requestParameters: DeletePlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling deletePlateforme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete Plateforme
     */
    async deletePlateforme(requestParameters: DeletePlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deletePlateformeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve current plateforme
     */
    async getCurrentPlateformeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentPlateformeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve current plateforme
     */
    async getCurrentPlateforme(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentPlateformeResponse> {
        const response = await this.getCurrentPlateformeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get plateforme by ID
     */
    async getPlateformeByIDRaw(requestParameters: GetPlateformeByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlateformeDto>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getPlateformeByID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlateformeDtoFromJSON(jsonValue));
    }

    /**
     * Get plateforme by ID
     */
    async getPlateformeByID(requestParameters: GetPlateformeByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlateformeDto> {
        const response = await this.getPlateformeByIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the \"corporate\" PersonneMorale tied to an OrganizationUnit, stored via the ABP ExtraProperty `OwnerPersonneMoraleId` on the OU. Returns null when not yet designated. 
     * Get the corporate PersonneMorale of an plateforme
     */
    async getPlateformeCorporatePersonneMoraleRaw(requestParameters: GetPlateformeCorporatePersonneMoraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlateformeCorporatePersonneMoraleDto>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling getPlateformeCorporatePersonneMorale().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/corporate-personne-morale`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlateformeCorporatePersonneMoraleDtoFromJSON(jsonValue));
    }

    /**
     * Returns the \"corporate\" PersonneMorale tied to an OrganizationUnit, stored via the ABP ExtraProperty `OwnerPersonneMoraleId` on the OU. Returns null when not yet designated. 
     * Get the corporate PersonneMorale of an plateforme
     */
    async getPlateformeCorporatePersonneMorale(requestParameters: GetPlateformeCorporatePersonneMoraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlateformeCorporatePersonneMoraleDto> {
        const response = await this.getPlateformeCorporatePersonneMoraleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get plateformes
     */
    async getPlateformesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlateformeListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/liste`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlateformeListResponseFromJSON(jsonValue));
    }

    /**
     * Get plateformes
     */
    async getPlateformes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlateformeListResponse> {
        const response = await this.getPlateformesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Link broker to Plateforme
     */
    async linkBrokerRaw(requestParameters: LinkBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling linkBroker().'
            );
        }

        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling linkBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/courtiers/{brokerId}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link broker to Plateforme
     */
    async linkBroker(requestParameters: LinkBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch current plateformes
     */
    async switchCurrentPlateformeRaw(requestParameters: SwitchCurrentPlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCurrentPlateformeResponse>> {
        const queryParameters: any = {};

        if (requestParameters['plateformeId'] != null) {
            queryParameters['plateformeId'] = requestParameters['plateformeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/current`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCurrentPlateformeResponseFromJSON(jsonValue));
    }

    /**
     * Patch current plateformes
     */
    async switchCurrentPlateforme(requestParameters: SwitchCurrentPlateformeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCurrentPlateformeResponse> {
        const response = await this.switchCurrentPlateformeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlink broker to Plateforme
     */
    async unlinkBrokerRaw(requestParameters: UnlinkBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling unlinkBroker().'
            );
        }

        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling unlinkBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/courtiers/{brokerId}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Unlink broker to Plateforme
     */
    async unlinkBroker(requestParameters: UnlinkBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.unlinkBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update plateforme by ID
     */
    async updatePlateformeByIdRaw(requestParameters: UpdatePlateformeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling updatePlateformeById().'
            );
        }

        if (requestParameters['updatePlateformeCommand'] == null) {
            throw new runtime.RequiredError(
                'updatePlateformeCommand',
                'Required parameter "updatePlateformeCommand" was null or undefined when calling updatePlateformeById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlateformeCommandToJSON(requestParameters['updatePlateformeCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update plateforme by ID
     */
    async updatePlateformeById(requestParameters: UpdatePlateformeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updatePlateformeByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload Plateforme Logo
     */
    async uploadPlateformeLogoRaw(requestParameters: UploadPlateformeLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['plateformeId'] == null) {
            throw new runtime.RequiredError(
                'plateformeId',
                'Required parameter "plateformeId" was null or undefined when calling uploadPlateformeLogo().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling uploadPlateformeLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/backoffice/plateformes/{plateformeId}/logos/{fileType}`.replace(`{${"plateformeId"}}`, encodeURIComponent(String(requestParameters['plateformeId']))).replace(`{${"fileType"}}`, encodeURIComponent(String(requestParameters['fileType']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Upload Plateforme Logo
     */
    async uploadPlateformeLogo(requestParameters: UploadPlateformeLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.uploadPlateformeLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
